var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.86596 7.99999L15.3007 2.5653C15.3987 2.47058 15.4769 2.35728 15.5307 2.23201C15.5846 2.10674 15.6129 1.97201 15.6141 1.83568C15.6153 1.69935 15.5893 1.56414 15.5377 1.43795C15.486 1.31177 15.4098 1.19713 15.3134 1.10072C15.217 1.00432 15.1023 0.928074 14.9761 0.876447C14.85 0.824821 14.7148 0.798842 14.5784 0.800027C14.4421 0.801211 14.3074 0.829536 14.1821 0.883348C14.0568 0.93716 13.9435 1.01538 13.8488 1.11345L8.41411 6.54814L2.97942 1.11345C2.78577 0.926414 2.52641 0.822921 2.25719 0.825261C1.98798 0.8276 1.73045 0.935585 1.54008 1.12596C1.34971 1.31633 1.24172 1.57385 1.23938 1.84307C1.23704 2.11228 1.34054 2.37165 1.52757 2.5653L6.96226 7.99999L1.52757 13.4347C1.42951 13.5294 1.35128 13.6427 1.29747 13.768C1.24366 13.8932 1.21533 14.028 1.21415 14.1643C1.21297 14.3006 1.23894 14.4358 1.29057 14.562C1.3422 14.6882 1.41844 14.8028 1.51484 14.8993C1.61125 14.9957 1.72589 15.0719 1.85208 15.1235C1.97826 15.1752 2.11347 15.2011 2.2498 15.1999C2.38614 15.1988 2.52087 15.1704 2.64614 15.1166C2.77141 15.0628 2.88471 14.9846 2.97942 14.8865L8.41411 9.45184L13.8488 14.8865C14.0424 15.0736 14.3018 15.1771 14.571 15.1747C14.8402 15.1724 15.0978 15.0644 15.2881 14.874C15.4785 14.6836 15.5865 14.4261 15.5888 14.1569C15.5912 13.8877 15.4877 13.6283 15.3007 13.4347L9.86596 7.99999Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.655d9a42685d733de99f893561cb639e.svg";
export { ForwardRef as ReactComponent };